const TOKEN_KEY = "stockos_token";
const USER_KEY = "stockos_user";
const PROJECT_KEY = "stockos_project";

// Token
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthenticated = () => !!getToken();

// User
export const setUser = (user) => localStorage.setItem(USER_KEY, JSON.stringify(user));
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
};
export const getRole = () => getUser()?.role ?? null;
export const clearUser = () => localStorage.removeItem(USER_KEY);

// Current project
export const setCurrentProject = (id) => localStorage.setItem(PROJECT_KEY, id);
export const getCurrentProject = () => localStorage.getItem(PROJECT_KEY);
export const clearCurrentProject = () => localStorage.removeItem(PROJECT_KEY);

// Atomic logout
export const logout = () => {
  clearToken();
  clearUser();
  clearCurrentProject();
};
